import React, { createContext, useState, useEffect } from "react";
import { auth, db } from "../firebase";
import { doc, onSnapshot } from "firebase/firestore";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        // Fetch user data from Firestore
        const userRef = doc(db, "users", currentUser.uid);
        const unsubscribeUserData = onSnapshot(userRef, (docSnap) => {
          if (docSnap.exists()) {
            setUserData(docSnap.data());
          } else {
            setUserData(null);
          }
          setLoading(false);
        }, (error) => {
          // Handle permission errors gracefully, especially during logout
          if (error.code === 'permission-denied') {
            console.warn('Permission denied accessing user data, likely due to logout');
            setUserData(null);
            setLoading(false);
          } else {
            console.error('Error fetching user data:', error);
          }
        });
        return () => unsubscribeUserData();
      } else {
        setUserData(null);
        setLoading(false);
      }
    });
    return () => unsubscribe(); // Cleanup subscription on unmount
  }, []);

  return (
    <UserContext.Provider value={{ user, userData, loading }}>
      {!loading && children}
    </UserContext.Provider>
  );
};

export default UserContext;
